import type { CompareProduct, TechSpecGroup } from '@/compare/types';

type BuildCompareDataResult = {
  allGroupsMap: Map<string, string[]>;
  optionTitles: string[];
};

function getTechData(product: CompareProduct): TechSpecGroup[] {
  let data: TechSpecGroup[] = product.techData || [];

  if (data.length === 0) {
    const el = document.getElementById(`tech-data-${product.id}`);
    if (el) {
      try {
        data = JSON.parse(el.textContent || '[]');
      } catch {
        data = [];
      }
    }
  }

  return data;
}

export function buildCompareData(products: CompareProduct[]): BuildCompareDataResult {
  const allGroupsMap = new Map<string, string[]>();

  const optionTitles = (products[0]?.optionNames || '').split('||').filter(Boolean);

  products.forEach((product) => {
    const data = getTechData(product);

    if (!data.length) return;

    data.forEach((group) => {
      if (!allGroupsMap.has(group.group_name)) {
        allGroupsMap.set(group.group_name, []);
      }

      const labels = allGroupsMap.get(group.group_name)!;

      group.specs.forEach((s) => {
        if (!labels.includes(s.label)) {
          labels.push(s.label);
        }
      });
    });
  });

  return {
    allGroupsMap,
    optionTitles,
  };
}
